import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * cn — combina clsx + tailwind-merge para unificar clases Tailwind sin duplicados.
 * Patrón estándar Wipxap/shadcn.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
